import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { General_Interface } from 'src/app/Interface/General_Interface';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class LetterrequestcustomerFactorService {

  constructor(private http: HttpClient) { }

  GetFactor(id: number): Observable<any> {
    return this.http.get(environment.BaseUrl
      + "Daro/LetterrequestcustomerFactor/GetFactor?id=" + id).pipe(
        map(data => {
          return data as any
        })
      )
  }


  Add(src: String, letter_id: number): Observable<any> {
    return this.http.get(environment.BaseUrl
      + "Daro/LetterrequestcustomerFactor/Add?src=" + src
      + "&letter_id=" + letter_id).pipe(
        map(data => {
          return data as any
        })
      )
  }


  Delete(id: number): Observable<any> {
    return this.http.get(environment.BaseUrl
      + "Daro/LetterrequestcustomerFactor/Delete?id=" + id).pipe(
        map(data => {
          return data as any
        })
      )
  }

  uploadFile(body) {

    const headers = new HttpHeaders().set('content-type', 'application/json');
    return this.http.post(environment.BaseUrl + "Daro/LetterrequestcustomerFactor/Upload", body).pipe(
      map(data => {

        return data
      })
    )
  }


}
